import Sip from '@/modules/jssip/jssip.module'
import CallMonitoringModule from '@/modules/jssip/monitoring.module'
export default {
  install (Vue) {
    Vue.prototype.$sip = new Sip()
    Vue.prototype.$mitoring = new CallMonitoringModule()
  }
}
